import { css } from 'emotion';

export const submit = css(`
	width: 100%;
`);
